import isObject from 'lodash-es/isObject';
import { GeolocationService } from '../geolocation/geolocation.service';
import { ConfigService } from '@core/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../geolocation/geolocation.service";
import * as i2 from "../../core/config.service";
var Affiliation;
(function (Affiliation) {
    Affiliation["STD_GST"] = "STD_GST";
    Affiliation["FL_RESIDENT"] = "FL_RESIDENT";
    Affiliation["STANDARD_GUEST"] = "STANDARD_GUEST";
    Affiliation["CALIFORNIA_RESIDENT"] = "CALIFORNIA_RESIDENT";
    Affiliation["BAJA_RESIDENT"] = "BAJA_RESIDENT";
    Affiliation["SOUTHERN_CALIFORNIA_RESIDENT"] = "SOUTHERN_CALIFORNIA_RESIDENT";
    Affiliation["FLORIDA_RESIDENT"] = "FLORIDA_RESIDENT";
    Affiliation["UK_RESIDENT"] = "UK_RESIDENT";
    Affiliation["CANADA_RESIDENT"] = "CANADA_RESIDENT";
    Affiliation["TEXAS_RESIDEN"] = "TEXAS_RESIDEN";
})(Affiliation || (Affiliation = {}));
var AffiliationsService = /** @class */ (function () {
    function AffiliationsService(geolocationService, configService) {
        this.geolocationService = geolocationService;
        this.configService = configService;
        this.affiliationsJar = 'AFFILIATIONS_jar';
        this.defaultAffiliations = {
            dlr: { storedAffiliations: [Affiliation.STD_GST] },
            wdw: { storedAffiliations: [Affiliation.STD_GST] },
            pep: { storedAffiliations: [Affiliation.STD_GST] },
        };
        this.WEST_USA_RESIDENT = 'WEST_USA_RESIDENT';
        this.EAST_USA_RESIDENT = 'EAST_USA_RESIDENT';
        this.WEST_CANADA_RESIDENT = 'WEST_CANADA_RESIDENT';
        this.EAST_CANADA_RESIDENT = 'EAST_CANADA_RESIDENT';
        this.FLORIDA_RESIDENT = 'FL_RESIDENT';
        this.TEXAS_RESIDENT = 'TX_RESIDENT';
        this.CALIFORNIA_RESIDENT = 'CAL_RESIDENT';
        this.BAJA_RESIDENT = 'BAJA_RESIDENT';
        this.SOUTHERN_CALIFORNIA_RESIDENT = 'SOCAL_RESIDENT';
        this.UK_RESIDENT = 'UK_RESIDENT';
        this.CANADA_RESIDENT = 'CA_RESIDENT';
        this.STANDARD_GUEST = 'STD_GST';
        this.TEXAS_RESIDEN = 'TEXAS_RESIDEN';
        this.US_RESIDENT = 'US_RESIDENT';
        this.HK_RESIDENT = 'HK_RESIDENT';
        this.AU_RESIDENT = 'AU_RESIDENT';
        this.CN_RESIDENT = 'CN_RESIDENT';
        this.ID_RESIDENT = 'ID_RESIDENT';
        this.IN_RESIDENT = 'IN_RESIDENT';
        this.JP_RESIDENT = 'JP_RESIDENT';
        this.KR_RESIDENT = 'KR_RESIDENT';
        this.MS_RESIDENT = 'MS_RESIDENT';
        this.PI_RESIDENT = 'PI_RESIDENT';
        this.SG_RESIDENT = 'SG_RESIDENT';
        this.TH_RESIDENT = 'TH_RESIDENT';
        this.TW_RESIDENT = 'TW_RESIDENT';
        this.dcl = {
            // USA
            florida: this.FLORIDA_RESIDENT,
            washington: this.WEST_USA_RESIDENT,
            utah: this.WEST_USA_RESIDENT,
            oregon: this.WEST_USA_RESIDENT,
            nevada: this.WEST_USA_RESIDENT,
            'new mexico': this.WEST_USA_RESIDENT,
            idaho: this.WEST_USA_RESIDENT,
            colorado: this.WEST_USA_RESIDENT,
            california: this.WEST_USA_RESIDENT,
            arizona: this.WEST_USA_RESIDENT,
            texas: this.TEXAS_RESIDENT,
            'new york': this.EAST_USA_RESIDENT,
            pennsylvania: this.EAST_USA_RESIDENT,
            connecticut: this.EAST_USA_RESIDENT,
            'district of columbia': this.EAST_USA_RESIDENT,
            massachusetts: this.EAST_USA_RESIDENT,
            maryland: this.EAST_USA_RESIDENT,
            'rhode island': this.EAST_USA_RESIDENT,
            oklahoma: this.TEXAS_RESIDENT,
            louisiana: this.TEXAS_RESIDENT,
            hawaii: this.WEST_USA_RESIDENT,
            montana: this.WEST_USA_RESIDENT,
            maine: this.EAST_USA_RESIDENT,
            'new hampshire': this.EAST_USA_RESIDENT,
            vermont: this.EAST_USA_RESIDENT,
            'new jersey': this.EAST_USA_RESIDENT,
            delaware: this.EAST_USA_RESIDENT,
            // West Canada
            alberta: this.WEST_CANADA_RESIDENT,
            'british columbia': this.WEST_CANADA_RESIDENT,
            manitoba: this.WEST_CANADA_RESIDENT,
            saskatchewan: this.WEST_CANADA_RESIDENT,
            // East Canada
            'new brunswick': this.EAST_CANADA_RESIDENT,
            'newfoundland and labrador': this.EAST_CANADA_RESIDENT,
            'nova scotia': this.EAST_CANADA_RESIDENT,
            ontario: this.EAST_CANADA_RESIDENT,
            'prince edward island': this.EAST_CANADA_RESIDENT,
            quebec: this.EAST_CANADA_RESIDENT,
            priorityOrder: null
        };
        this.dlr = {
            // used for DLR content
            california: this.CALIFORNIA_RESIDENT,
            'baja california': this.BAJA_RESIDENT,
            // Zip code range
            CAL_RESIDENT: {
                zipMin: 90000,
                zipMax: 93599,
                affiliation: this.SOUTHERN_CALIFORNIA_RESIDENT
            },
            priorityOrder: [
                'standard',
                'cal_resident',
                'socal_resident'
            ]
        };
        this.wdw = {
            // used for WDW content
            florida: this.FLORIDA_RESIDENT,
            'united kingdom': this.UK_RESIDENT,
            canada: this.CANADA_RESIDENT,
            priorityOrder: [
                'standard',
                'fl_resident',
                'canada_resident'
            ]
        };
        this.hkdl = {
            florida: this.FLORIDA_RESIDENT,
            'united kingdom': this.UK_RESIDENT,
            'canada': this.CANADA_RESIDENT,
            'united states': this.US_RESIDENT,
            'hong kong': this.HK_RESIDENT,
            'australia': this.AU_RESIDENT,
            'china': this.CN_RESIDENT,
            'Indonesia': this.ID_RESIDENT,
            'india': this.IN_RESIDENT,
            'japan': this.JP_RESIDENT,
            'south korea': this.KR_RESIDENT,
            'malaysia': this.MS_RESIDENT,
            'philippines': this.PI_RESIDENT,
            'singapore': this.SG_RESIDENT,
            'thailand': this.TH_RESIDENT,
            'taiwan': this.TW_RESIDENT,
            priorityOrder: [
                'standard',
                'fl_resident',
                this.HK_RESIDENT
            ]
        };
        this.pep = Object.assign(this.dlr, this.wdw);
        this.AFFILIATIONS = {
            'dcl': this.dcl,
            'dlr': this.dlr,
            'wdw': this.wdw,
            'hkdl': this.hkdl,
            'pep': this.pep
        };
        this.AFFILIATION_STRINGS = {
            'STANDARD': this.STANDARD_GUEST,
            'CALIFORNIA': this.CALIFORNIA_RESIDENT,
            'BAJA': this.BAJA_RESIDENT,
            'SOCAL': this.SOUTHERN_CALIFORNIA_RESIDENT,
            'FLORIDA': this.FLORIDA_RESIDENT,
            'UNITED_KINGDOM': this.UK_RESIDENT,
            'CANADA': this.CANADA_RESIDENT,
            'TEXAS': this.TEXAS_RESIDENT
        };
        this.affiliationList = this.AFFILIATION_STRINGS;
        this.setAffiliations = {};
        this.siteId = this.configService.getValue('siteId');
        this.affiliationPriorityList = this.AFFILIATIONS[this.siteId].priorityOrder;
    }
    AffiliationsService.prototype.getPriorityAffiliations = function () {
        return this.affiliationPriorityList;
    };
    AffiliationsService.prototype.getAffiliations = function () {
        var _this = this;
        var storage = window.sessionStorage;
        var affiliationsJarData = {};
        var storageAvailable = false;
        // Check if storage is available
        if (storage) {
            try {
                storageAvailable = storage.storageAvailable = true;
            }
            catch (error) {
                // fail silently
            }
        }
        // If storage is available and affil in storage pull data
        if (storageAvailable && storage[this.affiliationsJar]) {
            affiliationsJarData = JSON.parse(storage[this.affiliationsJar]);
        }
        if (isObject(affiliationsJarData) && affiliationsJarData[this.siteId]) {
            // Affiliation data is set and brand exists
            return Promise.resolve(affiliationsJarData);
        }
        else {
            var self_1 = this;
            var affiliationData_1 = this.defaultAffiliations[this.siteId] || [];
            var brandAffiliations = this.AFFILIATIONS[this.siteId] || {};
            return this.getGeolocation(brandAffiliations, affiliationData_1).then(function () {
                console.log('geo: getGeolocation.then');
                if (self_1.setAffiliations[_this.siteId]) {
                    return self_1.setAffiliations[_this.siteId](affiliationData_1);
                }
                else {
                    return Promise.resolve();
                }
            }).then(function () {
                // Add this.siteId affiliationData to json object
                affiliationsJarData[_this.siteId] = {
                    'storedAffiliations': affiliationData_1
                };
                // Change object to string and place in sessionStorage
                storage[_this.affiliationsJar] = JSON.stringify(affiliationsJarData);
                return affiliationsJarData;
            });
        }
    };
    AffiliationsService.prototype.getGeolocation = function (possibleAffiliations, affiliations) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.geolocationService.getGeoCode().subscribe(function (geodata) {
                console.log('geo: geodata', geodata);
                var region = geodata.state || geodata.region;
                if (possibleAffiliations.hasOwnProperty(region)) {
                    var state = possibleAffiliations[region];
                    affiliations.push(state);
                    if (possibleAffiliations[state] &&
                        possibleAffiliations[state].zipMin &&
                        possibleAffiliations[state].zipMax &&
                        possibleAffiliations[state].affiliation) {
                        var zip = geodata.zip || geodata.zipCode, zipMin = possibleAffiliations[state].zipMin, zipMax = possibleAffiliations[state].zipMax;
                        if (zip >= zipMin && zip <= zipMax) {
                            affiliations.push(possibleAffiliations[state].affiliation);
                        }
                    }
                }
                else if (possibleAffiliations.hasOwnProperty(geodata.country)) {
                    affiliations.push(possibleAffiliations[geodata.country]);
                }
                resolve(null);
            });
        });
    };
    AffiliationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AffiliationsService_Factory() { return new AffiliationsService(i0.ɵɵinject(i1.GeolocationService), i0.ɵɵinject(i2.ConfigService)); }, token: AffiliationsService, providedIn: "root" });
    return AffiliationsService;
}());
export { AffiliationsService };
